import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
// import logo from 'assets/img/illustrations/recycle-24023_1280.png';
import logo from 'assets/img/illustrations/csvc.png';

const Logo = ({ at = 'auth',  className, ...rest }) => {
  return (
    <Link
      to="/app"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img src={logo} alt="Logo" width={("128px")} />
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

export default Logo;

/*
// Vers.1

        <img className="me-2" src={logo} alt="Logo" width={width} />
        <span className={classNames('font-sans-serif', textClass, 'csvc-logo')}>CSVC</span>
*/